import React, { useState } from "react";

const BlurImage = ({ src, alt = "", className = "" }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
      <img
        src={src}
        alt={alt}
        onLoad={() => setIsLoading(false)}
        className={`duration-500 ease-in-out ${
          isLoading ? "blur-lg scale-105" : "blur-0 scale-100"
        } ${className}`}
      />
  );
};

export default BlurImage;
